import Controller from "./backupplans.controller";
import template from "./backupplans.html";

const backupplans = {
  template,
  controller: Controller,
};

export default backupplans;



// WEBPACK FOOTER //
// ./src/pages/backupplans/backupplans.component.js